import { FC } from "react";
import { Link, useParams } from "react-router-dom";
import InnerPage from "../../../shared/components/InnerPage";
import { PATHS } from "../../../paths";
import { BLOG_POSTS } from "../posts";

const BlogDetailPage: FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = BLOG_POSTS.find((item) => item.slug === slug);

  if (!post) {
    return (
      <InnerPage
        eyebrow="Blog"
        title="Yazı bulunamadı"
        crumbs={[{ label: "Blog", to: PATHS.blog }, { label: "Yazı bulunamadı" }]}
        seoDescription="Aradığınız blog yazısı bulunamadı."
      >
        <div className="it-notfound" style={{ gridColumn: "1 / -1" }}>
          <p>Aradığınız yazı yayında değil ya da adresi değişmiş olabilir.</p>
          <Link className="it-btn" to={PATHS.blog}>
            Tüm Yazılar
          </Link>
        </div>
      </InnerPage>
    );
  }

  return (
    <InnerPage
      eyebrow={post.tag}
      title={post.heading}
      crumbs={[{ label: "Blog", to: PATHS.blog }, { label: post.title }]}
      seoDescription={post.desc}
      withSidebar
    >
      <article className="it-article">
        <div className="it-article-img">
          <img src={post.image} alt={post.heading} />
        </div>
        <div dangerouslySetInnerHTML={{ __html: post.content }} />
      </article>
    </InnerPage>
  );
};

export default BlogDetailPage;
